module.exports = __webpack_public_path__ + "web/img/z5.74717319.png";